import moment from 'moment'

export function isEmail(email: string) {
  let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  if (email.match(regex)) return true
  else return false
}

export function hasDuplicates(array: any) {
  return new Set(array).size !== array.length
}

export function enumerateDaysBetweenDates(
  startDate: Date,
  endDate: Date,
  excludedDays: Array<number> = []
) {
  var dates = Array<any>()
  var currDate = moment(startDate).startOf('day')
  var lastDate = moment(endDate).startOf('day')

  while (currDate.diff(lastDate) <= 0) {
    const curDay = currDate.day();
    if (excludedDays.findIndex((x) => x === curDay) > -1) {
      currDate.add(1, 'days')
      continue
    }
    dates.push(currDate.clone().toDate())
    currDate.add(1, 'days')
  }
  return dates
}

export function formatMomentTime(time?: any | null): string {
  return moment(new Date().toDateString() + ' ' + time.hours + ':' + time.minutes).format('h:mm a')
}

export function formatDateToCalendar(date: any): string {
  return moment(date).format('MM/DD/YYYY')
}

export function formatDateToGrid(date: any): string {
  return moment(date).format('DD/MM/YYYY')
}

export function formatCurrency(amount){
    return (Math.round(amount * 100) / 100).toFixed(2)
}